export const DETAILS = {
  RUN_DATE: 'Run Date:',
  ELIGIBILITY: 'Eligibility Criteria',
  RULE: 'Rule Details',
  BACK: 'Back',
  CLEAR: 'Clear Form',
  DOWNLOAD_CSV: 'Download CSV',
};
